import React from 'react';
import { BET_STATUS_COLORS } from '../../constants';
import { mapBetStatus } from '../../../MyBets/utils';
import classes from './BetStatusBadge.module.scss';

const BetStatusBadge = ({ variant }) => {
  const colors = BET_STATUS_COLORS[variant] ?? BET_STATUS_COLORS.pending;
  const text = mapBetStatus(variant).toUpperCase();
  return (
    <span
      className={classes.Badge}
      data-status={variant}
      style={{
        color: colors.color,
        backgroundColor: colors.bg,
        borderColor: colors.color,
      }}
    >
      <span className={classes.Label}>{text}</span>
    </span>
  );
};

export default BetStatusBadge;
